import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-methoden',
  templateUrl: './methoden.component.html',
  styleUrls: ['./methoden.component.scss']
})
export class MethodenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
